
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/for-nutritionists",
      function () {
        return require("private-next-pages/for-nutritionists/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/for-nutritionists"])
      });
    }
  